import { defineMessages } from 'react-intl';

export const resultsMessages = defineMessages({
    'results.title': {
        id: 'results.title',
        defaultMessage: 'Screening Results',
        description: 'Title for the screening results page.',
    },
    'results.subtitle': {
        id: 'results.subtitle',
        defaultMessage:
            'Your {date} results indicate you may have {level} {resultType}.',
        description: 'Displayed after the user completes a screening.',
    },
    'results.based_on_your_results': {
        id: 'results.based_on_your_results',
        defaultMessage:
            'Based on your screening results, you may have symptoms of {anxiety} anxiety and {depression} depression.',
        description: 'Explanation of the user’s results.',
    },
    'results.based_on_your_results.asymptomatic': {
        id: 'results.based_on_your_results.asymptomatic',
        defaultMessage:
            'Based on your screening results, you do not appear to be experiencing symptoms of anxiety or depression.',
        description: 'Explanation of the user’s asymptomatic results.',
    },
    'results.progression.severe.title': {
        id: 'results.progression.severe.title',
        defaultMessage:
            'Your results are consistent with someone who may have severe depression.',
        description: 'Explanation of the user’s results.',
    },
    'results.progression.stable.title': {
        id: 'results.progression.stable.title',
        defaultMessage: "You're putting in the work!",
        description:
            'Displayed to the user to encourage them to continue engaging with their programs.',
    },
    'results.progression.stable.subtitle': {
        id: 'results.progression.stable.subtitle',
        defaultMessage:
            "Keep going and let's continue to check in on your journey. Changes don't happen overnight.",
        description:
            'Displayed to the user to encourage them to continue engaging with their programs.',
    },
    'results.progression.improving.title': {
        id: 'results.progression.improving.title',
        defaultMessage:
            'Based on your results, you have updates since the last time you checked in.',
        description:
            'Displayed to the user to highlight changes in their results.',
    },
    'results.progression.improving.subtitle': {
        id: 'results.progression.improving.subtitle',
        defaultMessage:
            'We encourage you to keep going and continue to check in on your journey moving forward.',
        description:
            'Displayed to the user to encourage them to continue engaging with their programs.',
    },
    'results.progression.worsening.title': {
        id: 'results.progression.worsening.title',
        defaultMessage: "You're putting in the work!",
        description:
            'Displayed to the user to encourage them to continue engaging with their programs.',
    },
    'results.progression.worsening.subtitle': {
        id: 'results.progression.worsening.subtitle',
        defaultMessage:
            "Keep going and let's continue to check in on your journey. Changes don't happen overnight.",
        description:
            'Displayed to the user to encourage them to continue engaging with their programs.',
    },
    'results.results_not_diagnoses': {
        id: 'results.results_not_diagnoses',
        defaultMessage: '*Results are not diagnoses',
        description: 'Disclaimer',
    },
    'results.retake_mental_health_survey': {
        id: 'results.retake_mental_health_survey',
        defaultMessage: 'Retake The Mental Health Survey',
        description: 'Button to retake the mental health survey.',
    },
    'results.retake_screening': {
        id: 'results.retake_screening',
        defaultMessage: 'Retake the Screening',
        description: 'Button to retake the mental health survey.',
    },
    'results.depression': {
        id: 'results.depression',
        defaultMessage: 'Depression',
        description: 'Depression',
    },
    'results.anxiety': {
        id: 'results.anxiety',
        defaultMessage: 'Anxiety',
        description: 'Anxiety',
    },
    'results.mental_health_statistics': {
        id: 'results.mental_health_statistics',
        defaultMessage: 'Mental Health Statistics',
        description: 'Title for the mental health statistics section.',
    },
    'results.proceed': {
        id: 'results.proceed',
        defaultMessage: 'Proceed To Your Plan',
        description: 'Button to proceed to the user’s plan.',
    },
    'results.label.asymptomatic': {
        id: 'results.label.asymptomatic',
        defaultMessage: 'Minimal',
        description:
            'The user has few or no symptoms of a mental health condition.',
    },
    'results.label.subclinical': {
        id: 'results.label.subclinical',
        defaultMessage: 'Minimal',
        description:
            'The user has few or no symptoms of a mental health condition.',
    },
    'results.label.mild': {
        id: 'results.label.mild',
        defaultMessage: 'Mild',
        description: 'The user has some symptoms of a mental health condition.',
    },
    'results.label.moderate': {
        id: 'results.label.moderate',
        defaultMessage: 'Moderate',
        description: 'The user has some symptoms of a mental health condition.',
    },
    'results.label.moderatesevere': {
        id: 'results.label.moderatesevere',
        defaultMessage: 'Moderately Severe',
        description: 'The user has many symptoms of a mental health condition.',
    },
    'results.label.severe': {
        id: 'results.label.severe',
        defaultMessage: 'Severe',
        description: 'The user has many symptoms of a mental health condition.',
    },
    'results.label.suicidal': {
        id: 'results.label.suicidal',
        defaultMessage: 'Suicidal',
        description:
            'The user has extreme symptoms of a mental health condition.',
    },
    'results.label_lowercase.asymptomatic': {
        id: 'results.label_lowercase.asymptomatic',
        defaultMessage: 'minimal',
        description:
            'The user has few or no symptoms of a mental health condition.',
    },
    'results.label_lowercase.subclinical': {
        id: 'results.label_lowercase.subclinical',
        defaultMessage: 'minimal',
        description:
            'The user has few or no symptoms of a mental health condition.',
    },
    'results.label_lowercase.mild': {
        id: 'results.label_lowercase.mild',
        defaultMessage: 'mild',
        description: 'The user has some symptoms of a mental health condition.',
    },
    'results.label_lowercase.moderate': {
        id: 'results.label_lowercase.moderate',
        defaultMessage: 'moderate',
        description: 'The user has some symptoms of a mental health condition.',
    },
    'results.label_lowercase.moderatesevere': {
        id: 'results.label_lowercase.moderatesevere',
        defaultMessage: 'moderately severe',
        description: 'The user has many symptoms of a mental health condition.',
    },
    'results.label_lowercase.severe': {
        id: 'results.label_lowercase.severe',
        defaultMessage: 'severe',
        description: 'The user has many symptoms of a mental health condition.',
    },
    'results.label_lowercase.suicidal': {
        id: 'results.label_lowercase.suicidal',
        defaultMessage: 'suicidal',
        description:
            'The user has extreme symptoms of a mental health condition.',
    },
    'results.statistics.one_in_five_american_adults.title': {
        id: 'results.statistics.one_in_five_american_adults.title',
        defaultMessage: '1 in 5 American adults',
        description: 'Statistic about mental health.',
    },
    'results.statistics.one_in_five_american_adults.subtitle': {
        id: 'results.statistics.one_in_five_american_adults.subtitle',
        defaultMessage: 'will experience a mental health issue each year.',
        description: 'Statistic about mental health.',
    },
    'results.statistics.fifty_percent_americans.title': {
        id: 'results.statistics.fifty_percent_americans.title',
        defaultMessage: '50% of Americans',
        description: 'Statistic about mental health.',
    },
    'results.statistics.fifty_percent_americans.subtitle': {
        id: 'results.statistics.fifty_percent_americans.subtitle',
        defaultMessage:
            'will meet the criteria for a diagnosable mental health condition sometime in their life.',
        description: 'Statistic about mental health.',
    },
    'results.statistics.fifty_percent_of_mental_health_issues.title': {
        id: 'results.statistics.fifty_percent_of_mental_health_issues.title',
        defaultMessage: '50% of mental health issues',
        description: 'Statistic about mental health.',
    },
    'results.statistics.fifty_percent_of_mental_health_issues.subtitle': {
        id: 'results.statistics.fifty_percent_of_mental_health_issues.subtitle',
        defaultMessage: 'begin by age 14, 75% by age 24.',
        description: 'Statistic about mental health.',
    },
    'results.statistics.one_in_two_adults.title': {
        id: 'results.statistics.one_in_two_adults.title',
        defaultMessage: '1 in 2 Adults',
        description: 'Statistic about mental health.',
    },
    'results.statistics.one_in_two_adults.subtitle': {
        id: 'results.statistics.one_in_two_adults.subtitle',
        defaultMessage:
            'will experience a mental health issue in their lifetime.',
        description: 'Statistic about mental health.',
    },
    'results.statistics.thirty_one_percent_us_adults.title': {
        id: 'results.statistics.thirty_one_percent_us_adults.title',
        defaultMessage: '31% of U.S. adults',
        description: 'Statistic about mental health.',
    },
    'results.statistics.thirty_one_percent_us_adults.subtitle': {
        id: 'results.statistics.thirty_one_percent_us_adults.subtitle',
        defaultMessage:
            'experience any anxiety disorder at some time in their lives.',
        description: 'Statistic about mental health.',
    },
    'results.statistics.millions_of_people.title': {
        id: 'results.statistics.millions_of_people.title',
        defaultMessage: '264 million',
        description: 'Statistic about mental health.',
    },
    'results.statistics.millions_of_people.subtitle': {
        id: 'results.statistics.millions_of_people.subtitle',
        defaultMessage: 'people suffering from depression worldwide.',
        description: 'Statistic about mental health.',
    },
    'results.mental_health_by_the_numbers': {
        id: 'results.mental_health_by_the_numbers',
        defaultMessage:
            'Mental Health By the Numbers | NAMI: National Alliance on Mental Illness',
        description: 'Statistic about mental health.',
    },
    'results.national_institute_of_mental_health_anxiety': {
        id: 'results.national_institute_of_mental_health_anxiety',
        defaultMessage:
            'National Institute of Mental Health >> Any Anxiety Disorder',
        description: 'Organization that provides mental health statistics.',
    },
    'results.national_institute_of_mental_health_depression': {
        id: 'results.national_institute_of_mental_health_depression',
        defaultMessage:
            'National Institute of Mental Health >> Major Depression',
        description: 'Organization that provides mental health statistics.',
    },
    'results.screenings_pager': {
        id: 'results.screenings_pager',
        defaultMessage: 'Screenings {min} - {max}',
        description: 'Displayed below the paginated screening results',
    },
    'results.screening_history_point': {
        id: 'results.screening_history_point',
        defaultMessage: 'Screening {position}, {date}, {label} score {score}',
        description: 'Label for a point on the screening history chart',
    },
    'results.gad_info.title': {
        id: 'results.gad_info.title',
        defaultMessage: 'Anxiety Scale',
        description: 'Title for the anxiety results graph',
    },
    'results.gad_info.scales.minimal': {
        id: 'results.gad_info.scales.minimal',
        defaultMessage: 'Minimal 0-4',
        description: 'Scale for the anxiety results graph',
    },
    'results.gad_info.scales.mild': {
        id: 'results.gad_info.scales.mild',
        defaultMessage: 'Mild 5-9',
        description: 'Scale for the anxiety results graph',
    },
    'results.gad_info.scales.moderate': {
        id: 'results.gad_info.scales.moderate',
        defaultMessage: 'Moderate 10-14',
        description: 'Scale for the anxiety results graph',
    },
    'results.gad_info.scales.severe': {
        id: 'results.gad_info.scales.severe',
        defaultMessage: 'Severe 15-21',
        description: 'Scale for the anxiety results graph',
    },
    'results.phq_info.title': {
        id: 'results.phq_info.title',
        defaultMessage: 'Depression Scale',
        description: 'Title for the depression results graph',
    },
    'results.phq_info.scales.minimal': {
        id: 'results.phq_info.scales.minimal',
        defaultMessage: 'Minimal 0-4',
        description: 'Scale for the depression results graph',
    },
    'results.phq_info.scales.mild': {
        id: 'results.phq_info.scales.mild',
        defaultMessage: 'Mild 5-9',
        description: 'Scale for the depression results graph',
    },
    'results.phq_info.scales.moderate': {
        id: 'results.phq_info.scales.moderate',
        defaultMessage: 'Moderate 10-14',
        description: 'Scale for the depression results graph',
    },
    'results.phq_info.scales.moderately_severe': {
        id: 'results.phq_info.scales.moderately_severe',
        defaultMessage: 'Moderately Severe 15-19',
        description: 'Scale for the depression results graph',
    },
    'results.phq_info.scales.severe': {
        id: 'results.phq_info.scales.severe',
        defaultMessage: 'Severe 20-27',
        description: 'Scale for the depression results graph',
    },
});

export default resultsMessages;
